(function () {
  "use strict";
  var C = window.STORE_CONFIG, T = window.STORE_CONTENT, M = window.STORE_MEDIA, Cart = window.StoreCart, money = Cart.money;
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var text = function (id, v) { $(id).textContent = v; };
  var ICONS = {
    truck: '<path d="M2.5 6.5h11v10h-11zM13.5 10h4l3.5 3.5v3h-7.5"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    shield: '<path d="M12 3l7.5 3v5.5c0 4.6-3.2 8-7.5 9.5-4.3-1.5-7.5-4.9-7.5-9.5V6z"/><path d="M8.8 12l2.3 2.3 4.2-4.3"/>',
    lock: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>',
    box: '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/>',
    check: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 12l2.4 2.4 4.6-4.8"/>',
    heart: '<path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.3 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z"/>',
    spark: '<path d="M12 3l1.8 6.2L20 11l-6.2 1.8L12 19l-1.8-6.2L4 11l6.2-1.8z"/>',
    bolt: '<path d="M13 3L5.5 13.5H11L10 21l8-11h-5.5z"/>',
  };
  var icon = function (k) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICONS[k] + "</svg>"; };

  document.title = C.productName;
  if (C.logo) $("logo-img").src = C.logo;
  $("logo-link").setAttribute("aria-label", C.brand + " home");
  text("product-title", C.productName);
  text("footer-copy", "© " + new Date().getFullYear() + ", " + C.brand + ".");

  var group = '<span class="gs-ticker__group">' + [0, 1, 2, 3].map(function () {
    return T.ticker.map(function (t) { return '<span class="gs-ticker__item">' + esc(t) + '<i class="gs-neon-dot"></i></span>'; }).join("");
  }).join("") + "</span>";
  $("ticker").innerHTML = group + group;

  var gi = 0, G = M.gallery;
  function gallery() {
    $("gallery-main").innerHTML = '<img src="' + esc(G[gi].file) + '" alt="' + esc(G[gi].alt) + '" width="1254" height="1254"' + (gi === 0 ? ' fetchpriority="high"' : "") + ">";
    $("gallery-thumbs").innerHTML = G.map(function (m, i) {
      return '<button type="button" class="gs-thumb' + (i === gi ? " is-active" : "") + '" data-i="' + i + '" aria-label="Image ' + (i + 1) + " of " + G.length + '" aria-pressed="' + (i === gi) + '"><img src="' + esc(m.thumb) + '" alt="" width="240" height="240" loading="lazy"></button>';
    }).join("");
  }
  var go = function (i) { gi = (i + G.length) % G.length; gallery(); };
  $("gallery-thumbs").addEventListener("click", function (e) { var b = e.target.closest("[data-i]"); if (b) go(Number(b.getAttribute("data-i"))); });
  $("gallery-prev").addEventListener("click", function () { go(gi - 1); });
  $("gallery-next").addEventListener("click", function () { go(gi + 1); });

  $("benefits").innerHTML = '<div class="glow-highlight"><div class="glow-highlight-icon" aria-hidden="true">' + T.highlight.icon + '</div><div><div class="glow-title">' + esc(T.highlight.title) + '</div><div class="glow-subtitle">' + esc(T.highlight.subtitle) + "</div></div></div>" +
    '<div class="glow-perks">' + T.perks.map(function (p) { return '<div class="glow-perk"><span class="glow-emoji" aria-hidden="true">' + p.icon + '</span><div><div class="glow-perk-title">' + esc(p.title) + '</div><div class="glow-perk-desc">' + esc(p.text) + "</div></div></div>"; }).join("") + "</div>";
  text("bundle-heading", T.bundleHeading);
  text("atc-label", T.ctaLabel); text("sticky-atc", T.ctaLabel);
  $("pay-icons").innerHTML = $("pay-icons-footer").innerHTML = (window.GS_PAYMENT_ICONS || []).join("");
  $("trust").innerHTML = T.trust.map(function (t) { return "<li>" + icon(t.icon) + "<span" + (t.icon === "truck" ? ' id="trust-ship"' : "") + ">" + esc(t.text) + "</span></li>"; }).join("");
  text("faq-heading", T.faqHeading); text("faq-intro", T.faqIntro);
  $("faq-list").innerHTML = T.faq.map(function (f) {
    return '<details class="gs-faq-item"><summary><span class="gs-faq-icon">' + icon(f.icon) + "</span><span>" + esc(f.q) + '</span><span class="gs-faq-plus" aria-hidden="true"></span></summary>' + f.a.map(function (p) { return "<p>" + esc(p) + "</p>"; }).join("") + "</details>";
  }).join("");
  if (C.guarantee && C.guarantee.days) { text("guarantee", C.guarantee.days + "-Day Money Back Guarantee"); $("guarantee").hidden = false; }

  text("guide-heading", T.guide.heading);
  $("guide-images").innerHTML = M.guide.map(function (m) { return '<img src="' + esc(m.file) + '" alt="' + esc(m.alt) + '" width="1000" height="1000" loading="lazy" decoding="async">'; }).join("");
  text("showcase-heading", T.showcase.heading); text("note-title", T.showcase.noteTitle); text("note-text", T.showcase.note);
  $("videos").innerHTML = M.videos.map(function (v) { return '<video src="' + esc(v) + '" muted loop playsinline autoplay preload="metadata" aria-label="GlowStrike Neon gameplay video"></video>'; }).join("");
  text("experience-eyebrow", T.experience.eyebrow); text("experience-heading", T.experience.heading); text("experience-text", T.experience.text);
  $("experience-items").innerHTML = T.experience.items.map(function (p) { return '<li><strong><span>' + esc(p.n) + "</span> " + esc(p.title) + "</strong><p>" + esc(p.text) + "</p></li>"; }).join("");
  $("weapon-modes").src = M.weaponModes.file; $("weapon-modes").alt = M.weaponModes.alt;
  text("closing-eyebrow", T.closing.eyebrow); text("closing-heading", T.closing.heading); text("closing-text", T.closing.text);

  var RV = T.reviews, shown = RV.firstShown;
  text("reviews-heading", RV.heading); text("reviews-intro", RV.intro); text("reviews-more", RV.more);
  function reviews() {
    $("reviews-grid").innerHTML = RV.items.slice(0, shown).map(function (r) {
      var stars = ""; for (var i = 1; i <= 5; i++) stars += '<span aria-hidden="true">' + (i <= r.rating ? "★" : "☆") + "</span>";
      return '<article class="glow-review"><div class="glow-review-person"><div class="glow-review-avatar" aria-hidden="true">' + esc(r.name.charAt(0)) + '</div><div class="glow-review-name">' + esc(r.name) + "</div></div>" +
        '<div class="glow-review-stars" role="img" aria-label="' + r.rating + ' out of 5 stars">' + stars + '</div><h3 class="glow-review-title">' + esc(r.title) + '</h3><p class="glow-review-text">' + esc(r.text) + "</p>" +
        (r.photo ? '<div class="glow-review-photo"><button type="button" data-photo="' + esc(r.photo) + '" aria-label="View photo from ' + esc(r.name) + '"><img src="' + esc(r.photo) + '" alt="Laser tag set product image" width="600" height="450" loading="lazy"></button></div>' : "") + "</article>";
    }).join("");
    $("reviews-more-area").hidden = shown >= RV.items.length;
  }
  $("reviews-more").addEventListener("click", function () { shown = RV.items.length; reviews(); });
  $("reviews-grid").addEventListener("click", function (e) {
    var b = e.target.closest("[data-photo]"); if (!b) return;
    $("review-lightbox-img").src = b.getAttribute("data-photo"); $("review-lightbox").classList.add("is-open"); $("review-close").focus();
  });
  function closeLightbox() { $("review-lightbox").classList.remove("is-open"); }
  $("review-close").addEventListener("click", closeLightbox);
  $("review-lightbox").addEventListener("click", function (e) { if (e.target === this) closeLightbox(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeLightbox(); });

  function addonRow(o, g, s, on) {
    var rule = Cart.addonRule(o, g.id); if (!rule) return "";
    var v = g.variants[0], free = rule === "free", added = free || s.addons[g.id] === v.id;
    var box = on && !free ? '<input type="checkbox" data-addon="' + esc(g.id) + '" data-variant="' + esc(v.id) + '"' + (added ? " checked" : "") + ' aria-label="Add ' + esc(g.name) + '">' : on ? '<span class="gs-tick" aria-hidden="true">✓</span>' : "";
    return '<label class="gs-addon' + (on ? " is-on" : "") + '">' + box + '<img src="' + esc(g.image) + '" alt="" width="30" height="30"><span class="gs-addon-name">' + (free ? "Free " : "") + esc(g.name) + '</span><span class="gs-prices"><b>' + money(free ? 0 : Cart.cents(v.price)) + "</b><s>" + money(Cart.cents(v.compareAt)) + "</s></span></label>";
  }
  var LOW = 50;
  function stockLine(o) {
    var n = Cart.stock().left[o.id]; if (n == null) return "";
    var boxes = n + (n === 1 ? " box left" : " boxes left");
    return '<span class="gs-stock' + (n <= LOW ? " is-low" : "") + '">' + (n <= LOW ? "Low stock: " : "") + boxes + "</span>";
  }
  function offers(s) {
    $("offer-cards").innerHTML = C.offers.map(function (o) {
      var on = o.id === s.offer;
      if (o.soldOut) {
        return '<div class="gs-tier is-sold" aria-disabled="true"><div class="gs-tier-head"><input type="radio" name="offer" value="' + esc(o.id) + '" disabled aria-label="' + esc(o.title) + ', sold out">' +
          '<img src="' + esc(o.image) + '" alt="" width="48" height="48"><span class="gs-tier-name"><strong>' + esc(o.title) + "</strong>" + (o.badge ? "<em>" + esc(o.badge) + "</em>" : "") + "<small>" + esc(o.detail) + "</small></span>" +
          '<span class="gs-prices gs-prices-lg"><b>' + money(Cart.cents(o.price)) + "</b><s>" + money(Cart.cents(o.compareAt)) + '</s></span><span class="gs-sold">SOLD OUT</span></div></div>';
      }
      return '<div class="gs-tier' + (on ? " is-selected" : "") + (o.includes ? " has-radio" : "") + '" data-offer="' + esc(o.id) + '"><label class="gs-tier-head"><input type="radio" name="offer" value="' + esc(o.id) + '"' + (on ? " checked" : "") + ">" +
        (o.includes ? "" : '<img src="' + esc(o.image) + '" alt="" width="48" height="48">') +
        '<span class="gs-tier-name"><strong>' + esc(o.title) + "</strong>" + (o.badge ? '<em>' + esc(o.badge) + "</em>" : "") + "<small>" + esc(o.detail) + "</small>" + stockLine(o) + "</span>" +
        '<span class="gs-prices gs-prices-lg"><b>' + money(Cart.cents(o.price)) + "</b><s>" + money(Cart.cents(o.compareAt)) + "</s></span></label>" +
        (o.includes ? '<div class="gs-includes"><img src="' + esc(o.image) + '" alt="" width="48" height="48"><span>' + esc(o.includes) + "</span></div>" : "") +
        (C.addons || []).map(function (g) { return addonRow(o, g, s, on); }).join("") + "</div>";
    }).join("");
  }
  $("offer-cards").addEventListener("change", function (e) {
    if (e.target.name === "offer") Cart.set({ offer: e.target.value });
    var g = e.target.getAttribute("data-addon");
    if (g) { var p = {}; p[g] = e.target.checked ? e.target.getAttribute("data-variant") : null; Cart.set({ addons: p }); }
  });
  $("offer-cards").addEventListener("click", function (e) {
    var t = e.target.closest("[data-offer]"); if (!t || e.target.closest("input")) return;
    if (t.getAttribute("data-offer") !== Cart.get().offer) { e.preventDefault(); Cart.set({ offer: t.getAttribute("data-offer") }); }
  });

  function preorder() {
    var st = Cart.stock(), P = T.preorder, open = C.offers.some(function (o) { return !o.soldOut; });
    var label = !open ? "Sold out" : st.preorder ? P.ctaLabel : T.ctaLabel;
    $("preorder-notice").hidden = !st.preorder;
    if (st.preorder) { text("preorder-header", P.header); text("preorder-message", P.message.replace("{window}", st.window)); text("preorder-description", P.description); text("preorder-footer", P.footer); }
    text("atc-label", label); text("sticky-atc", label);
    $("atc").disabled = $("sticky-atc").disabled = !open;
  }
  function render(s, o) {
    offers(s); preorder();
    text("trust-ship", s.offer === "squad" || s.offer === "ultimate" ? "Free tracked shipping" : "Tracked shipping");
    text("sticky-title", o.offer.title); text("sticky-total", money(o.subtotal));
  }

  // Add to cart goes straight to Shopify checkout. Add-ons follow the offer's rules, and a free add-on is added at $0 so it shows on the order.
  function cartLines() {
    var s = Cart.get(), o = Cart.offerById(s.offer), lines = [o.variantId];
    (C.addons || []).forEach(function (g) {
      var rule = Cart.addonRule(o, g.id);
      if (rule === "free") lines.push(g.includedVariantId);
      else if (rule === "paid" && s.addons[g.id]) lines.push(g.variants[0].variantId);
    });
    return lines;
  }
  var adding = false;
  function addToCart() {
    if (adding) return;
    var lines = cartLines();
    if (lines.some(function (id) { return !id; })) return;
    adding = true;
    var permalink = function () { location.href = "/cart/" + lines.map(function (id) { return id + ":1"; }).join(","); };
    var post = function (url, data) {
      return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(data) }).then(function (r) { if (!r.ok) throw new Error(r.status); });
    };
    post("/cart/clear.js", {}).then(function () {
      return post("/cart/add.js", { items: lines.map(function (id) { return { id: id, quantity: 1 }; }) });
    }).then(function () { location.href = "/checkout"; }).catch(permalink);
  }
  window.addEventListener("pageshow", function () { adding = false; });
  $("atc").addEventListener("click", addToCart);
  $("sticky-atc").addEventListener("click", addToCart);
  var stickyQueued = false;
  function sticky() { stickyQueued = false; $("sticky-bar").hidden = $("atc").getBoundingClientRect().bottom > 0; }
  window.addEventListener("scroll", function () { if (!stickyQueued) { stickyQueued = true; requestAnimationFrame(sticky); } }, { passive: true });
  window.addEventListener("resize", sticky);

  gallery(); reviews();
  Cart.onChange(render);
  render(Cart.get(), Cart.order());
})();
